import { Instance, types } from 'mobx-state-tree';

const BusinessUnit = types
	.model('BusinessUnit', {
		id: types.identifierNumber,
		name: types.string,
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}));

export default BusinessUnit;

export interface IBusinessUnitModel extends Instance<typeof BusinessUnit> {}
